import type { CSSProperties, PropsWithChildren } from 'react';
import styled, { keyframes } from 'styled-components';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';

const itemWidth = 160;

const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  min-height: 128px;
  background: rgba(var(--c-rgb-black), 0.4);
`;

const LoadingIndicatorContainer = styled.div`
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
`;

export const GridOverlayLoadingIndicator = () => {
  return (
    <LoadingOverlay>
      <LoadingIndicatorContainer>
        <LoadingIndicator />
      </LoadingIndicatorContainer>
    </LoadingOverlay>
  );
};
const appearIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Grid = styled.div<{ columns?: number }>`
  display: grid;
  gap: var(--double-unit);
  grid-template-columns: repeat(
    var(--columns, auto-fill),
    minmax(calc(${itemWidth}px / var(--columns, 1)), 1fr)
  );
  > * {
    animation: 0.3s ${appearIn} ease-in-out forwards;
  }
`;
export const MarketGrid = ({ children }: PropsWithChildren) => {
  const mobileColumns = 2;

  const isTabletAndAbove = useIsTabletAndAbove();

  return (
    <Grid
      style={
        !isTabletAndAbove
          ? ({ '--columns': mobileColumns } as CSSProperties)
          : undefined
      }
    >
      {children}
    </Grid>
  );
};
